import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const MailSendersRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings', 'role--settings--mail-senders']}>
    <Route index element={<Index />} />
  </SubRouter>
))
